// src/components/Calendar/CalendarSidebar.js
import React from 'react';
import {
  Box,
  Typography,
  TextField,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Divider,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

export default function CalendarSidebar({
  vehicles,
  vrmFilter,
  onVrmFilterChange,
  onVrmClick,
  onEditClick,
}) {
  return (
    <Box
      sx={{
        width: { xs: '100%', md: 300 },
        borderRadius: 2,
        p: 2.5,
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        background:
          'linear-gradient(to right, rgba(2,11,58,0.9), rgba(2,11,58,0.96))',
      }}
    >
      <Typography variant="h6" sx={{ mb: 0.5 }}>
        Vehicle Schedule
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, opacity: 0.8 }}>
        Filter upcoming test & expiry dates by registration.
      </Typography>

      <Typography
        variant="caption"
        sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}
      >
        Search VRM
      </Typography>

      <TextField
        variant="outlined"
        size="small"
        value={vrmFilter}
        onChange={(e) => onVrmFilterChange(e.target.value)}
        placeholder="e.g. KP71ZHX"
        sx={{
          mt: 0.5,
          mb: 2,
          '& .MuiOutlinedInput-root': {
            color: 'white',
            '& fieldset': {
              borderColor: 'rgba(255,255,255,0.4)',
            },
            '&:hover fieldset': {
              borderColor: '#00a2ff',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#00a2ff',
            },
          },
          '& input::placeholder': {
            color: 'rgba(255,255,255,0.7)',
          },
        }}
      />

      <Typography variant="caption" sx={{ mb: 1 }}>
        {vrmFilter ? 'Vehicles matching filter:' : 'All vehicles:'}
      </Typography>

      <Box sx={{ flexGrow: 0, maxHeight: 260, overflowY: 'auto' }}>
        <List dense disablePadding>
          {vehicles.length === 0 && (
            <ListItem>
              <ListItemText
                primary="No vehicles match this filter."
                primaryTypographyProps={{
                  sx: { color: 'rgba(255,255,255,0.7)', fontSize: 13 },
                }}
              />
            </ListItem>
          )}

          {vehicles.map((v) => (
            <ListItem
              key={v.vrm}
              button
              onClick={() => onVrmClick(v.vrm)}
              sx={{ py: 0.25, display: 'flex', alignItems: 'center' }}
            >
              <ListItemText
                primary={v.vrm}
                primaryTypographyProps={{ sx: { fontSize: 13 } }}
              />
              <IconButton
                size="small"
                edge="end"
                onClick={(e) => {
                  e.stopPropagation();
                  onEditClick(v.vrm);
                }}
                sx={{
                  color: 'rgba(255,255,255,0.8)',
                  '&:hover': { color: '#00a2ff' },
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </ListItem>
          ))}
        </List>
      </Box>

      <Divider sx={{ my: 2, borderColor: 'rgba(255,255,255,0.3)' }} />

      <Box sx={{ fontSize: 12 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <span className="legend-dot plate" />
          <span>Plate expiry</span>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <span className="legend-dot interim" />
          <span>Interim test</span>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <span className="legend-dot booking" />
          <span>Booking test</span>
        </Box>
      </Box>
    </Box>
  );
}
